module.exports = __webpack_public_path__ + "img/icons-unlock.97cb6262.svg";